<template>
  <div class="top-bar-menu flex-row-align-center">
    <div class="menu-host">
      <i class="material-icons square-button mar-right-10 mar-left-10">add</i>
      <div class="menu-options smooth-shadow">
        <router-link to="/studio">
          <p><i class="material-icons mar-right-10 md-18">map</i>New Console</p>
        </router-link>
        <router-link to="/new-entity">
          <p>
            <i class="material-icons mar-right-10 md-18">scatter_plot</i>New
            Entity
          </p>
        </router-link>
      </div>
    </div>
    <div class="profile-icon menu-host">
      <div class="flex-row-align-center">
        <img src="@/assets/avatar.png" class="clickable" />
        <div class="flex-col user-details-area">
          <h3 class="name">{{ userData.name || "No username" }}</h3>
          <p class="email">{{ userData.email || "No email" }}</p>
        </div>
        <i class="material-icons md-18 mar-left-10">keyboard_arrow_down</i>
      </div>
      <div class="menu-options smooth-shadow">
        <!-- <div>
          <p>
            <i class="material-icons md-18 mar-right-10">settings</i> Settings
          </p>
        </div>-->
        <a
          href="https://localeai.gitbook.io/locale-ai-platform-guide/"
          target="_blank"
          ref="noopener"
        >
          <p><i class="material-icons md-18 mar-right-10">help</i> help</p>
        </a>
        <div @click="signOut()">
          <p>
            <i class="material-icons md-18 mar-right-10">exit_to_app</i> SignOut
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      userData: {},
    };
  },
  methods: {
    ...mapActions("User", ["signOut", "getUserData"]),
    notify() {
      this.$notify({
        group: "main",
        title: "Hello There!",
        text: "Successfully signed in",
        type: "success",
      });
    },
  },
  created() {
    this.getUserData().then(data => {
      this.userData = data;
    });
  },
};
</script>

<style lang="scss">
.top-bar-menu {
  .menu-host {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    &:hover > .menu-options {
      display: flex !important;
    }

    .menu-options {
      position: absolute;
      display: none;
      flex-direction: column;
      width: 220px;
      border-radius: 5px;
      top: 60px;
      right: -10px;
      background: var(--color-secondary);
      border: 1px solid var(--border-color);
      color: var(--font-color);

      div,
      a {
        display: block;
        padding: 15px 20px;
        color: var(--font-color);

        &:hover {
          cursor: pointer;
          background-color: var(--color-primary-light);
          color: var(--color-primary);
        }

        p {
          margin: 0;
          padding: 0;
          display: flex;
          align-items: center;

          &.email {
            opacity: 0.6;
          }
        }
      }
    }
  }

  .profile-icon {
    display: flex;
    align-items: center;

    .user-details-area {
      max-width: 150px;

      .name {
        font-size: 1em;
        //font-weight: bold;
      }
      .email {
        margin: 0;
        opacity: 0.6;
        font-size: 0.8em;
      }
    }

    img {
      height: 35px;
      width: 35px;
      border-radius: 50%;
      margin: 0 10px;
    }
  }
}
</style>
